import { Box, Button, Flex, LoadingIndicator } from '@sainsburys-tech/fable'
import React from 'react'

const Loading = ({ message }: { message?: string }) => (
  <Flex
    direction='column'
    alignItems='center'
    justifyContent='center'
    style={{ minHeight: '60vh', width: '100%' }}
  >
    <Box
      as='div'
      backgroundColor='secondary'
      style={{
        padding: '2rem',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '1.5rem',
      }}
    >
      <LoadingIndicator
        isLoading
        shouldPreventFocus
        variant='primary'
        size='md'
      />
      <div style={{ fontSize: '1.2rem', fontWeight: 500 }}>
        {!message || message === 'none'
          ? 'Loading...'
          : `${message.charAt(0).toUpperCase() + message.slice(1)}...`}
      </div>
      <Button
        onClick={() => (window.location.href = window.location.origin)}
        testid='refresh-button'
      >
        Refresh
      </Button>
    </Box>
  </Flex>
)

export default Loading
